import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { DOCUMENT_KINDS } from "utils/constants";
import EditDynamic from "./Dynamic";
import EditStatic from "./Static";

const VIEW_BY_KIND = {
  [DOCUMENT_KINDS.DYNAMIC]: () => <EditDynamic />,
  [DOCUMENT_KINDS.STATIC]: () => <EditStatic />,
};

const Edit = () => {
  const { state } = useLocation();
  const View = useMemo(
    () => VIEW_BY_KIND[state?.kind] || VIEW_BY_KIND[DOCUMENT_KINDS.DYNAMIC],
    [state?.kind],
  );
  return View();
};

export default Edit;
